/**
 * sessionStorage key holding the in-app path to return to after the Zoom OAuth round-trip. Set by ZoomConnection when
 * the user clicks Connect (before the full-page redirect to Zoom) and read by AppLinks when the callback lands.
 *
 * Kept in its own dependency-free module (not the ZoomConnection component) so that AppLinks — a core routing
 * container in MainContainer's eagerly-loaded graph — can read the key without importing the component and its
 * transitive deps (the queries barrel, components-v2, etc.), which would risk a circular import.
 */
export const ZOOM_CONNECT_RETURN_PATH_KEY = 'zoomConnectReturnPath';

/**
 * localStorage key recording that the user dismissed the Zoom connect banner on the Schedule Meeting page. Once set,
 * the banner stays hidden there (they can still manage Zoom from Personal Settings).
 */
export const ZOOM_SCHEDULE_BANNER_DISMISSED_KEY = 'zoomScheduleMeetingBannerDismissed';
